import { i18n } from '@lingui/core';
import { en, de, it } from 'make-plural/plurals'
import { store } from './store'


export const locales = {
  en: "English",
  de: "Deutsch",
  it: "Italiano"
};
export const defaultLocale = store.getState().currentUser.language;

i18n.loadLocaleData({
  en: { plurals: en },
  de: { plurals: de },
  it: { plurals: it }
})

/**
* We do a dynamic import of just the catalog that we need
* @param locale any locale string
*/
export async function dynamicActivate(locale) { ///}: string) {

  //console.log('dynamicActivate language ...', locale)

  const { messages } = await import(`./locales/${locale}/messages`)  
  i18n.load(locale, messages)
  i18n.activate(locale)
}